import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./style.scss";
import "./style.scss";

function SubmitFormPopup(props) {
  // const [loading, setLoading] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const handleToggleCheck = () => setTermsChecked((prev) => !prev);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="submit__form__modal"
      dialogClassName="submit__form__modal_dialog"
    >
      <Modal.Body>
        <div className="submit__form__modal__body">
          <div className="modal__header">
            <h4>Confirm Submission</h4>
          </div>
          <div className="modal__description">
            <p>
              Before submitting, please ensure that all your answers are
              accurate to the best of your knowledge. You still have the
              opportunity to review and make changes if needed. Once submitted,
              responses will be final and cannot be modified.
            </p>
            <div className="check__box__container">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheckChecked"
                  onChange={handleToggleCheck}
                  checked={termsChecked}
                />
              </div>
              <h5>
                I confirm that I have reviewed my answers and confirm that they
                are truthful and accurate.
              </h5>
            </div>
            <div className="next__and__skip">
              <button
                // onClick={props?.onHide && props?.onHide}
                onClick={async  () => {
                  await props?.handleNext(false, false, "COMPLETED");
                  props?.onHide()
                }}
                disabled={!termsChecked}
              >
                Confirm to Submit Assessment
              </button>
              <button
                onClick={props?.onHide && props?.onHide}
                className="cancel__btn"
              >
                Return to Assessment
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SubmitFormPopup;
